import { observer } from 'mobx-react-lite';
import { FC, ReactElement } from 'react';
import { Controller } from 'react-hook-form';

import { useTranslation } from '@gem/modules/i18n';
import { Button, ButtonTypes, Selector } from '@gem/ui-kit';

import {
  IDiscoverDestinationSelectorFormProps,
  useDiscoverDestinationSelectorFormPresenter,
} from './DiscoverDestinationSelectorForm.presenter';
import styles from './DiscoverDestinationSelectorForm.styles.m.css';

export const DiscoverDestinationSelectorForm: FC<IDiscoverDestinationSelectorFormProps> = observer(
  (props) => {
    const { presenter, form } = useDiscoverDestinationSelectorFormPresenter(props);
    const { t } = useTranslation();

    return (
      <div className={styles.container}>
        <form
          className={styles.form}
          onSubmit={presenter.onSubmit}
        >
          <Controller
            control={form.control}
            name="destinationKey"
            render={({ field }): ReactElement => (
              <Selector
                isFullWidth
                items={presenter.destinationItems}
                className={styles.formControl}
                {...field}
                isDisabled={form.formState.isSubmitting || field.disabled}
              />
            )}
          />
          <Button
            className={styles.submit}
            type={ButtonTypes.Submit}
            theme="primary"
            size="20"
            isLoading={form.formState.isSubmitting}
            isDisabled={!form.formState.isValid}
          >
            {t('auth_continue')}
          </Button>
        </form>
      </div>
    );
  }
);
